<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="max-height: 300px;">


        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">图标</div>
            <el-upload
                action=""
                :limit="1"
                :on-preview="handlePictureCardPreview"
                :on-change="handleChange"
                :on-progress="onProgress"
                :on-success="imgSuccess"
                :on-error="imgError"
                :http-request="uploadHttp"
                list-type="picture-card"
                :on-remove="handleRemove"
                :class="{disabled:uploadDisabled}"
                :file-list="fileList">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :modal-append-to-body="false" :visible.sync="imgVisible" width="30%">
              <img width="100%" :src="dialogImageUrl" alt="图片未找到"/>
            </el-dialog>

          </el-col>
          <el-col :span="12" class="item">
            <div class="label">志愿者人数</div>
            <el-input v-model="add_volunteerCount" placeholder="请输入队伍人数"></el-input>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">登录账号</div>
            <el-input v-model="add_loginName" placeholder="请输入登录账号"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">密码</div>
            <el-input v-model="add_pwd" type="password" placeholder="请输入密码"></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">手机号</div>
            <el-input v-model="add_phone" placeholder="请输入手机号"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">志愿队伍名称</div>
            <el-input v-model="add_name" placeholder="请输入名称"></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24" class="item">
            <div class="label">地址</div>
            <el-input v-model="add_address" placeholder="请输入地址"></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24" class="item">
            <div class="label">简介</div>
            <el-input v-model="add_description" placeholder="请输入简介" type="textarea" :rows="5"></el-input>
          </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      add_loginName:'',
      add_pwd:'',
      add_phone:'',
      add_name:'',
      add_address:'',
      add_volunteerCount:0,
      add_description:'',

      add_imgPath:'',


      //上传身份证正面相关参数
      limitCount: 1,
      uploadDisabled: false,
      // 是否显示预览图片
      imgVisible: false,
      // 预览图片url
      dialogImageUrl: "",
      fileList: [],

    }
  },
  methods: {



    onProgress(event, file, fileList) {
      console.log(event,file,fileList);
      this.uploadDisabled = false;
    },
    // 图片上传成功
    imgSuccess(response, file, fileList) {
      console.log(response,file,fileList);
      this.uploadDisabled = true;
    },
    // 图片上传失败
    imgError(err, file, fileList) {
      console.log(err,file,fileList);
      this.uploadDisabled = true;
    },
    // 预览图片
    handlePictureCardPreview(file) {
      this.imgVisible = true;
      this.uploadDisabled = true;
      this.dialogImageUrl = file.url;
    },
    // 删除图片
    handleRemove(file, fileList) {
      console.log(file,fileList);
      this.uploadDisabled = false;
    },
    //图片更改
    handleChange(fileList) {
      this.uploadDisabled = fileList.length >= this.limitCount;
      this.uploadDisabled = true;
    },

    uploadHttp(file) {

      //获取文件信息
      //let fileLen = file.file;
      //let name = fileLen.name

      let fd = new FormData();
      fd.append('file',file.file);
      fd.append('staffCode',getStaffCode());
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.add_imgPath = that.$imgUrl+res.data.data.path;
      })


    },
    init(){

      this.add_loginName = '';
      this.add_pwd = '';
      this.add_phone='';
      this.add_name='';
      this.add_address = "";
      this.add_imgPath = '';
      this.add_volunteerCount = 0;

    },
    closeSelf() {
      this.loading= false
      this.$emit("closeAdd");
    },

    confirm(){

      if(this.add_loginName === ''){
        this.$message("请输入登录账号");
        return;
      }
      if(this.add_pwd === ''){
        this.$message("请输入密码");
        return;
      }
      if(this.add_phone === ''){
        this.$message("请输入手机号");
        return;
      }
      if(this.add_name === ''){
        this.$message("请输入名称");
        return;
      }
      if(this.add_address === ''){
        this.$message("请输入地址");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'VolunteerTeam/AddSaaS',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          loginName: this.add_loginName,
          password:this.add_pwd,
          phone:this.add_phone,
          name:this.add_name,
          address:this.add_address,
          volunteerCount:this.add_volunteerCount,
          description:this.add_description,
          imgPath:this.add_imgPath.replace(this.$imgUrl,""),

        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>


